import React, {FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Product} from "../../../api/GovernanceToolApi";

export const DeleteProductDialog: FunctionComponent<DeleteProductProps> = props => {
    const {t} = useTranslation();
    const {product, onCancelClick, onOkClick} = props;

    return <Dialog
        maxWidth="sm"
        aria-labelledby="confirmation-dialog-title"
        open={true}
        onClose={() => onCancelClick()}>
        <DialogTitle id="confirmation-dialog-title">{t("Delete product")}</DialogTitle>
        <DialogContent dividers>
            {t("deleteProductConfirmMessage", {productName: product.name, productVersion: product.version})}
        </DialogContent>
        <DialogActions>
            <Button onClick={() => onOkClick()} color="primary">
                {t("Ok")}
            </Button>
            <Button autoFocus onClick={() => onCancelClick()} color="primary">
                {t("Cancel")}
            </Button>
        </DialogActions>
    </Dialog>;
}

export interface DeleteProductProps {
    product: Product;

    onCancelClick: () => void;
    onOkClick: () => void;
}